<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiAccount }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Manage Account
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- END APP BAR -->

        <v-card v-if="getAccountEmailCpNo" class="memberInfoCard">
            <v-card-title>
                <h4>Edit Information</h4>
            </v-card-title>
            <v-card-text>
                <!-- Edit Email -->
                <div class="userInfo">
                    <div class="d-flex align-center">
                        <h4>Email Address:</h4>
                        <v-btn icon class="teal--text ml-2" @click="editEmail = !editEmail">
                            <v-icon>{{ mdiPen }}</v-icon>
                        </v-btn>
                    </div>
                    <h3>{{ getAccountEmailCpNo.EMAIL }}</h3>
                </div>

                <!-- Edit CP # -->
                <div class="userInfo">
                    <div class="d-flex align-center">
                        <h4>Cellphone #:</h4>
                        <v-btn icon class="teal--text ml-2" @click="editCpNo = !editCpNo">
                            <v-icon>{{ mdiPen }}</v-icon>
                        </v-btn>
                    </div>
                    <h3>{{ getAccountEmailCpNo.CPNO }}</h3>
                </div>

                <!-- Edit Address -->
                <div class="userInfo">
                    <div class="d-flex align-center">
                        <h4>Address: </h4>
                        <v-btn icon class="teal--text ml-2" @click="editAddress = !editAddress">
                            <v-icon>{{ mdiPen }}</v-icon>
                        </v-btn>
                    </div>
                    <h3 v-for="(line, index) in getAccountEmailCpNo.ADDRESS" :key="index">
                        <span v-for="(place, indexPlace) in line" :key="indexPlace">{{ place }} </span>
                    </h3>
                    <!--
          <h3>{{ getAccountEmailCpNo.ADDR_1 }}</h3>
          <h3>{{ getAccountEmailCpNo.ADDR_2 }}</h3>
          <h3>{{ getAccountEmailCpNo.BARANGAY }} {{ getAccountEmailCpNo.DISTRICT }} {{ getAccountEmailCpNo.CITY }}</h3>
          <h3>{{ getAccountEmailCpNo.PROVINCE }}</h3>
          <h3>{{ getAccountEmailCpNo.REGION }} {{ getAccountEmailCpNo.ZIP }}</h3>
          -->
                </div>

                <!-- Change pass -->
                <div class="userInfo">
                    <v-btn
                        class="teal white--text"
                        small
                        @click="editPass = !editPass"
                    >
                        <h1>Change password</h1>
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>

        <!-- DIALOG BOXES -->
        <!-- Added v-if to avoid error on render of null -->
        <dlgEditEmail
            v-if="getAccountEmailCpNo"
            :edit-email="editEmail"
            :user-email-add="getAccountEmailCpNo.EMAIL"
            @showDlgEditEmail="showEditEmail"
        />
        <dlgEditCPno
            v-if="getAccountEmailCpNo"
            :edit-cp-no="editCpNo"
            :user-cpno="getAccountEmailCpNo.CPNO"
            @showDlgEditCpNo="showEditCpNo"
        />

        <dlgEditAddress
            v-if="getAccountEmailCpNo"
            :edit-address="editAddress"
            :user-addr-1="getAccountEmailCpNo.ADDR_1"
            :user-addr-2="getAccountEmailCpNo.ADDR_2"
            :user-barangay="getAccountEmailCpNo.BARANGAY"
            :user-district="getAccountEmailCpNo.DISTRICT"
            :user-city="getAccountEmailCpNo.CITY"
            :user-province="getAccountEmailCpNo.PROVINCE"
            :user-region="getAccountEmailCpNo.REGION"
            :user-zip="getAccountEmailCpNo.ZIP"
            @showDlgEditAddress="showEditAddress"
        />
        <dlgEditPass :edit-pass="editPass" @showDlgEditPass="showEditPass" />
    </section>
</template>

<script>
import dlgEditEmail from './ManageAccountComp/dlgEditEmail.vue'
import dlgEditPass from './ManageAccountComp/dlgEditPass.vue'
import dlgEditCPno from './ManageAccountComp/dlgEditCPno.vue'
import dlgEditAddress from './ManageAccountComp/dlgEditAddress.vue'
import { mapActions, mapGetters } from 'vuex'
import { mdiAccount, mdiPen } from '@mdi/js'

export default {
    components: {
        dlgEditEmail,
        dlgEditPass,
        dlgEditCPno,
        dlgEditAddress
    },
    data: () => ({
        mdiAccount,
        mdiPen,
        editEmail: false,
        editCpNo: false,
        editPass: false,
        editAddress: false,
        address: []
    }),
    computed: {
        ...mapGetters(['getAccountEmailCpNo'])
    },
    async mounted() {
        // TODO: CHECK IF IT WORKS
        await this.userAccountCred({ MEMBN: this.$cookies.get('usermembn') })
    },
    methods: {
        // To avoid mutating a prop
        showEditEmail(editEmail) {
            this.editEmail = editEmail
        },
        showEditCpNo(editCpNo) {
            this.editCpNo = editCpNo
        },
        showEditPass(editPass) {
            this.editPass = editPass
        },
        showEditAddress(editAddress) {
            this.editAddress = editAddress
        },
        ...mapActions(['userAccountCred', 'getCsrfToken'])
    }
}
</script>

<style scoped>
section {
  background-image: url("../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.memberInfoCard {
  width: 50%;
  margin: auto;
}

.userInfo {
  margin: 20px 0px;
  color: black;
}
.userInfo h4 {
  font-weight: normal;
}
.userInfo h3 {
  padding-left: 15px;
}
.userInfo h1 {
  font-size: 18px;
}
@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}
@media (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .memberInfoCard {
    width: 90%;
  }
}
</style>
